import React, { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import '../../assets/stylesheets/ClubSlide/ClubSettings.scss';
import { getCurrentClubPendingMembers } from '../../store/selectors'
import { useSelector, useDispatch } from 'react-redux';

const findTabInner = selectedTab => tab => tab.name === selectedTab;

const TabSwitcher =({ tabs, defaultSelected }) => {
    const { t } = useTranslation();
    const memberList = useSelector(getCurrentClubPendingMembers);
    const [selectedTab, setSelectedTab] = useState(defaultSelected ? tabs[defaultSelected].name : tabs[0].name);
    const findTab = useMemo(() => findTabInner(selectedTab), [selectedTab]);
    const TabView = tabs.find(findTab).view;
    const tabProps = tabs.find(findTab).props;

    const selectTab = tab => {
        setSelectedTab(tab);
    }

    return (
        <React.Fragment>
            <div className="tab-selector-wrapper">
                <div className={`tab-selector`}>
                    {
                        tabs.map((tab, index) =>
                            <div 
                                className={`tab ${selectedTab === tab.name ? 'selected-tab' : ''}`} 
                                key={index}
                                onClick={()=>selectTab(tab.name)}
                            >
                                <span>{t(`tabTitle.${tab.name}`)}</span>
                                <span className={` ${selectedTab === tab.name ? 'selected' : ''}`}></span>
                                {tab.name === 'newMembers' && !!memberList.length && <span className={`new-member-count`}>{memberList.length}</span>}
                            </div>
                        )
                    }
                </div>
            </div>
            {TabView && <TabView {...tabProps} />} 
        </React.Fragment>
    );
};

export default TabSwitcher;